// import * as types from '@store/mutation-types'
import { getOrderAppealByOrderIdApi } from '@views/order/order.api.js'

// initial state
// shape: [{ id, quantity }]
const state = {
  orderDetail: {},
  questionContainerElement: null,
  photoCount: 0,
  cacheAnswers: null,
  errorMessages: [],
  isHistoryAnswer: false,

  // sjf 业务
  sjfOrderDetail: {},

  // 任务审核参照数据
  taskAuditReference: null,

  // 工单 ASR 风险检查结果
  asrCheckResult: null,
  // 点击风险标签后待跳转：{ recordUrl, beginMs, alias }
  asrCheckSeek: null,
  // 工单对应的申诉单（含 status 等），由 fetchOrderAppeal 统一拉取，避免重复请求
  orderAppeal: null,
  orderAppealLoading: false,
}

// getters
const getters = {
  isReviewPermission: (state, getters, rootState, rootGetters) => {
    let user = rootState.login.user
    let permissions = rootGetters.permissions
    // 用户审核权限
    return user.usertype === '1' || permissions.includes(20) || permissions.includes(21)
  },
  allowOrderReview: (state, getters, rootState, rootGetters) => {
    let detail = state.orderDetail
    return !detail.locked && // 锁定工单
      detail.status === '4' && // 工单状态: 待审核
      getters.isReviewPermission && // 用户审核权限
      !state.isHistoryAnswer // 查看历史审核答案
  },
  allowUserModifyAnswer: (state, getters, rootState, rootGetters) => {
    let detail = state.orderDetail
    let user = rootState.login.user
    let permissions = rootGetters.permissions
    return !detail.locked && detail.status === '5' && !getters.allowLiveOrderReview && (user.usertype === '1' || permissions.includes(222)) && detail.type !== '8'
  },
  allowModifyAnswer: (state, getters, rootState, rootGetters) => {
    return getters.allowUserModifyAnswer || getters.allowOrderReview
  },
  // 工单申诉审核：申诉中(status 20)的工单允许编辑证据
  allowOrderAppealReview: (state, getters, rootState, rootGetters) => {
    let detail = state.orderDetail
    return !detail.locked && String(detail.status) === '20' && getters.isReviewPermission && !state.isHistoryAnswer
  },
  allowLiveOrderReview: (state, getters, rootState, rootGetters) => {
    let detail = state.orderDetail
    return detail.type === '19'
  },
}

// actions
const actions = {
  getOrderDetail: {
    handler ({commit, state}, params) {
      let promised = request.alert('getOrderDetail', params)
      return promised
    },
  },
  setOrderDetail: {
    root: true,
    handler ({commit, dispatch, state}, params) {
      let promised = dispatch('getOrderDetail', params)
      promised.then((res) => {
        commit('SET_ORDER_DETAIL_DATA', res.data)
      }, Function.prototype)
      return promised
    },
  },
  updateOrderReviewAnswer: {
    root: true,
    handler ({commit, state}, params) {
      let promised = request.alert('updateOrderReviewAnswer', params)
      return promised
    },
  },
  uploadOrderReviewFile: {
    root: true,
    handler ({commit, state}, params) {
      let promised = request.alert('uploadOrderReviewDirectFile', params)
      return promised
    },
  },
  reviewOrderPass: {
    root: true,
    handler ({commit, state}, params) {
      let promised = request.alert('reviewOrderPass', params)
      return promised
    },
  },
  reviewOrderNotPass: {
    root: true,
    handler ({commit, state}, params) {
      let promised = request.alert('reviewOrderNotPass', params)
      return promised
    },
  },
  lockOrder: {
    root: true,
    handler ({commit, state}, params) {
      let promised = request.alert('lockOrder', params)
      return promised
    },
  },
  findRecognitionResults: {
    root: true,
    handler ({commit, state}, params) {
      let promised = request.alert('findRecognitionResults', params)
      return promised
    },
  },
  reviewClbOrderPass: {
    root: true,
    handler ({commit, state}, params) {
      let promised = request.alert('reviewClbOrderPass', params)
      return promised
    },
  },
  checkOrderStatus: {
    root: true,
    handler ({commit, state}, params) {
      let promised = request.alert('checkOrderStatus', params)
      return promised
    },
  },
  // 拉取工单对应的申诉单（申诉审核页与申诉详情面板共享，只请求一次）
  fetchOrderAppeal: {
    handler ({commit, state}, {id}) {
      if (!id) return Promise.resolve(null)
      commit('SET_ORDER_APPEAL_LOADING', true)
      return getOrderAppealByOrderIdApi({id}).then(res => {
        const body = (res && (res.data || res.detail)) || {}
        const appeal = body.detail ? body.detail : body
        // 申诉单关闭后接口可能不再返回该记录，保留已加载的数据，避免面板闪现“暂无申诉信息”
        if (appeal && appeal.status !== undefined) {
          commit('SET_ORDER_APPEAL', appeal)
        }
        return appeal
      }).catch(() => {
        // 网络异常也保留已加载数据
      }).finally(() => {
        commit('SET_ORDER_APPEAL_LOADING', false)
      })
    },
  },
}

// mutations
const mutations = {
  SET_ORDER_DETAIL_DATA (state, data) {
    data.locked = data.locked === '1'
    state.orderDetail = data
    state.isHistoryAnswer = false
  },
  // sjf 业务
  SET_SJF_ORDER_DETAIL_DATA (state, data) {
    state.sjfOrderDetail = data
  },
  SET_TASK_AUDIT_REFERENCE (state, data) {
    state.taskAuditReference = data || null
  },
  LOCK_ORDER (state) {
    state.orderDetail.locked = !state.orderDetail.locked
  },
  SET_QUESTION_CONTAINER_ELEMENT (state, value) {
    state.questionContainerElement = value
  },
  SET_CACHE_ANSWERS (state, value) {
    state.cacheAnswers = value
  },
  SET_HISTORY_ANSWERS (state, value) {
    state.cacheAnswers = value
    state.isHistoryAnswer = true
  },
  SET_PHOTO_COUNT (state, value) {
    state.photoCount = value
  },
  SET_ERROR_MESSAGES (state, value) {
    state.errorMessages = value
  },
  SET_ASR_CHECK_RESULT (state, value) {
    state.asrCheckResult = value || null
  },
  SET_ASR_CHECK_SEEK (state, value) {
    state.asrCheckSeek = value || null
  },
  SET_ORDER_APPEAL (state, data) {
    state.orderAppeal = data
  },
  SET_ORDER_APPEAL_LOADING (state, value) {
    state.orderAppealLoading = value
  },
}

export const orderReview = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/order-review/order-review.store.js